<svelte:options
    customElement={{
        tag: "mg-icon",
        shadow: "none",
    }}
/>

<script lang="ts">
    import "@phosphor-icons/web/bold";
    import "@phosphor-icons/web/fill";

    let {
        icon,
        iconSet = "bold",
        size = "lg",
        marginStart = false,
        marginEnd = false,
        centered = false,
    }: {
        icon: string;
        iconSet?: string;
        size?: string;
        marginStart?: boolean;
        marginEnd?: boolean;
        centered?: boolean;
    } = $props();
</script>

<i
    class:margin-start={marginStart}
    class:margin-end={marginEnd}
    class:centered
    class={[`ph-${icon}`, `ph-${size}`, `ph-${iconSet}`]}
    aria-hidden="true"
></i>

<style lang="scss">
    :global(mg-icon) {
        align-content: center;
        line-height: 1;
        font-size: 1rem;
    }

    .ph-xxs {
        font-size: 0.5em;
    }

    .ph-xs {
        font-size: 0.75em;
    }

    .ph-sm {
        font-size: 0.875em;
    }

    .ph-lg {
        font-size: 1.3333em;
        line-height: 1em;
        vertical-align: -0.25em;

        &.centered {
            vertical-align: -0.16em;
        }
    }

    .ph-xl {
        font-size: 1.5em;
        line-height: 1em;
    }

    .ph-1x {
        font-size: 1em;
    }

    .ph-2x {
        font-size: 2em;
    }

    .ph-3x {
        font-size: 3em;
    }

    .ph-4x {
        font-size: 4em;
    }

    .ph-5x {
        font-size: 5em;
    }

    .margin-start {
        margin-inline-start: 0.3em;
    }

    .margin-end {
        margin-inline-end: 0.3em;
    }
</style>
